module.exports = __webpack_public_path__ + "img/harpia-color full-iconAsset 11.993be3d8.png";